@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';

.modal-body-content {
  font-size: 14px;

  .contact-description-text {
    color: @shipfrom-contact-modal--contact-description--text-color;
    line-height: 21px;
    margin-bottom: 16px;
  }

  .label {
    font-weight: 400;
    height: 18px;
    line-height: 18px;
    font-size: 12px;

    .subtext {
      color: @shipfrom-contact-modal--subtext--text-color;
      font-size: 12px;
    }
  }

  .inline-input-wrapper {
    display: inline-block;
    margin-right: 8px;
  }

  .input {
    margin-bottom: 12px;

    &.phone-input {
      width: 134px;
    }
  }
}

.loading-indicator-container {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  .loading-indicator {
    height: 100px;
    width: 100px;
  }
}
